import { Box } from "@mui/material";
import { Modal } from "pepsico-ds";
import React from "react";
import AdminAppForm from "./AdminAppForm";
import "./AdminAppModal.css";
export default function AdminAppModal({ open, setOpen }) {
  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <Modal
      auxiliaryButtonProps={false}
      showPrimaryButton={false}
      showSecondaryButton={false}
      showTertiaryButton={false}
      linkProps={{}}
      className="app-modal"
      onCloseModal={() => {
        setOpen(false);
      }}
      hideCloseButton={false}
      showAuxiliaryButton={false}
      showModal={open}
      tertiaryButtonProps={{}}
      title="Add App"

      //   type={isMobile ? "L" : "S"}
    >
      <Box
        sx={{
          marginTop: "2.5rem",
        }}
      >
        <AdminAppForm onCancel={handleCancel} isEdit={false} />
      </Box>

      {/* Terms and Conditions Checkbox */}
    </Modal>
  );
}
